import RewardsV2Card from './RewardsV2Card';

export default RewardsV2Card;
